<span class="text-2xl font-semibold">Spaltenbasiert</span>
<div class="flex flex-row gap-4 p-24">
  <aw-button-group [id]="'buttonGroup'" [buttonsPerRow]="1" [formControl]="buttonControl"
    [options]="buttonGroup"></aw-button-group>
  <aw-button-group [id]="'buttonGroup'" [buttonsPerRow]="2" [formControl]="buttonControl"
    [options]="buttonGroup"></aw-button-group>
  <aw-button-group [id]="'buttonGroup'" [buttonsPerRow]="3" [formControl]="buttonControl"
    [options]="buttonGroup"></aw-button-group>
</div>
<span class="text-2xl font-semibold">Feste Größe</span>
<div class="flex flex-row gap-4 p-24">
  <aw-button-group [id]="'buttonGroup'" [formControl]="buttonControl" [options]="buttonGroup"></aw-button-group>
</div>

<div class="container mx-auto">
  <div class="flex items-center justify-start gap-5">
    <aw-button type="button" [id]="'1'" [style]="'primary'" (click)="toggleContext()">
      Toggle Context</aw-button>

    <span> Aktueller Kontext: {{ siteContextService.getContext() }} </span>
  </div>

  <div class="p-5">
    <div class="flex flex-wrap gap-5">
      <aw-button type="button" [id]="'1'" [style]="'primary'">Button</aw-button>
      <aw-button type="button" [id]="'3'" [style]="'primary-alt'">Button</aw-button>
      <aw-button type="button" [id]="'2'" [style]="'secondary'">Button</aw-button>
      <aw-button type="button" [id]="'6'" [style]="'secondary-alt'">Button</aw-button>
      <aw-button type="button" [id]="'4'" [style]="'error'">Button</aw-button>
      <aw-button type="button" [id]="'7'" [style]="'error-alt'">Button</aw-button>
      <aw-button type="button" [id]="'5'" [style]="'custom'">Button</aw-button>
      <aw-button type="button" [id]="'6'" [style]="'tertiary'">Button</aw-button>
    </div>
    <div class="flex flex-wrap gap-5">
      <aw-button type="button" [id]="'1d'" [style]="'primary'" [isDisabled]="true">Button</aw-button>
      <aw-button type="button" [id]="'3d'" [style]="'primary-alt'" [isDisabled]="true">Button</aw-button>
      <aw-button type="button" [id]="'2d'" [style]="'secondary'" [isDisabled]="true">Button</aw-button>
      <aw-button type="button" [id]="'6d'" [style]="'secondary-alt'" [isDisabled]="true">Button</aw-button>
      <aw-button type="button" [id]="'4d'" [style]="'error'" [isDisabled]="true">Button</aw-button>
      <aw-button type="button" [id]="'7d'" [style]="'error-alt'" [isDisabled]="true">Button</aw-button>
      <aw-button type="button" [id]="'5d'" [style]="'custom'" [isDisabled]="true">Button</aw-button>
      <aw-button type="button" [id]="'6d'" [style]="'tertiary'" [isDisabled]="true">Button</aw-button>
    </div>
  </div>
</div>